import { render, staticRenderFns } from "./Recast.vue?vue&type=template&id=de609ba2&"
import script from "./Recast.vue?vue&type=script&lang=js&"
export * from "./Recast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports